import { t } from "i18next";
import { ReactComponent as BagstageLogoWhite } from "../assets/bagstage_logo_white.svg";
import { ReactComponent as ArrivalModule } from "../assets/icons/bagstage_arrival_module.svg";
import { ReactComponent as DepartureModule } from "../assets/icons/bagstage_departure_module.svg";
import { ReactComponent as LoginIcon } from "../assets/icons/bagstage_login.svg";
import { ReactComponent as TransferModule } from "../assets/icons/bagstage_transfer_module.svg";
import AppChip from "../components/loginPage/AppChip";
import StandardButton from "../components/UI/buttons/StandardButton";
import { useAppSelector } from "../store/hooks";
import loginPageStyles from "../styles/login.module.css";

export default function LoginPage() {
  const { kcObject } = useAppSelector((state) => state.authenticationSlice);

  return (
    <div className="flex">
      <div className={loginPageStyles.landingPageImage}>
        <div className={loginPageStyles.backgroundBlur}>
          <div className={loginPageStyles.landingPageHeroText}>
            <BagstageLogoWhite />
            <div>
              <h1 className={loginPageStyles.subText}>
                {t("smarter-baggage-operations")}
              </h1>
              <h1 className={loginPageStyles.subText}>
                {t("less-stress-more-throughput")}
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className={loginPageStyles.rhsAppSection}>
        <div className={loginPageStyles.appsList}>
          <div className={loginPageStyles.appsListContainer}>
            <AppChip Icon={DepartureModule} title={t("departure")} />
            <AppChip Icon={ArrivalModule} title={t("arrival")} />
            <AppChip Icon={TransferModule} title={t("transfer")} />
          </div>
          <StandardButton
            onClick={() => kcObject?.login()}
            variant="primary"
            classes={loginPageStyles.landingPageButton}
            icon={<LoginIcon />}
          >
            {t("log-in")}
          </StandardButton>
        </div>
      </div>
    </div>
  );
}
